import { useEffect, useState } from 'react';
import {  useSelector } from 'react-redux';
import axios from 'axios';
import { formatDate, numberWithCommas } from '../../libs/generalFunctions';
import LottieHandler from '../../components/LottieHandler/LottieHandler';
import NavButtonsComp from '../../components/NavButtonsComp/NavButtonsComp';

import './salaryPage.scss'
import apiUrl from '../../libs/baseUrl';

function SalaryPage() {
    
    const token = useSelector(state => state.user.token)

//===State start here===    
    const [salaryData , setSalaryData] = useState({})

    const [loading,setLoading] = useState(false)

    const [error,setError] = useState(null);

//===State end here===    


//===Event handler start here===



//===Event handler end here===

//===useEffect start here===

useEffect(()=>{

    const fetchAuthmeTemp = async()=>{
        setLoading(true);
        try {
            const response = await axios.post(`${apiUrl}/auth/me`, 
              {},
              {
                headers: {
                  Authorization: `Bearer ${token}`
                }
              }
            );
            setSalaryData(response.data.data);
            if(!response.data.data.salary){
                setError("*لا يوجد بيانات راتب لعرضها يرجى مراجعة الموارد البشرية")
            }
            setLoading(false);
          } catch (error) {
            setLoading(false);
            setError(error.message);
          }
    }

    fetchAuthmeTemp();
},[])

//===useeffect end here===

  return (
    <div className='salaryPage'>
        
        <div className='salaryPage_container'>

        {
          loading ?
            <div style={{width:"100%",display:"flex",alignItems:"cneter",justifyContent:"center",marginBottom:"15rem"}} className='forLoadingSalary'>
                 
              <LottieHandler type="kite" message="يتم التحميل ..." />
                
            </div>
                :
           <>
  
<span className='error_Message' dir='rtl'>{error}</span>

<div className="salaryShow_container">


<span className='salaryShow_container_title'>الصافي</span>
<span className="salaryShow_number" dir="rtl">{salaryData?.salary?.net_salary ? numberWithCommas(salaryData?.salary?.net_salary) : 0}<span className="salaryShow_number_CountryCurrency" >ل.س</span> </span>
<div className="salaryShow_lastTimeUpdate_container">
    <span >{salaryData.salary ? formatDate(salaryData.salary?.date ): "2024-2-12"}</span>
    <span dir="rtl">تاريخ التحديث :</span>
</div>
</div>

<div className='salaryShow_info_container'>

<div className="salaryShow_info_left">

    <span className="salaryShow_info_left_title">معلومات الحسم</span>

    <div className="salaryShow_info_left_items">
      
      <div className="salaryShow_info_left_item">
        <span className="salaryShow_info_left_item_info" dir="rtl">{salaryData?.salary ? salaryData?.salary?.absence : 0}</span>
        <span className="salaryShow_info_left_item_title" dir="rtl">الغياب :</span>  
    </div>
    <div className="salaryShow_info_left_item">
        <span className="salaryShow_info_left_item_info" dir="rtl">{salaryData?.salary?.absence_cut ? numberWithCommas(salaryData?.salary?.absence_cut) : 0}</span>
        <span className="salaryShow_info_left_item_title" dir="rtl">حسم الغياب :</span>  
    </div>
    <div className="salaryShow_info_left_item">
        <span className="salaryShow_info_left_item_info" dir="rtl">{salaryData?.salary?.without_salary ? numberWithCommas(salaryData?.salary?.without_salary) : 0}</span>
        <span className="salaryShow_info_left_item_title" dir="rtl">بلا راتب :</span>  
    </div>
    <div className="salaryShow_info_left_item">
        <span className="salaryShow_info_left_item_info" dir="rtl">{salaryData?.salary?.without_salary_cut ? numberWithCommas(salaryData?.salary?.without_salary_cut) : 0}</span>
        <span className="salaryShow_info_left_item_title" dir="rtl">حسم بلا راتب :</span>  
    </div>
    <div className="salaryShow_info_left_item">
        <span className="salaryShow_info_left_item_info" dir="rtl">{salaryData?.salary?.late_cut ? numberWithCommas(salaryData?.salary?.late_cut) : 0}</span>
        <span className="salaryShow_info_left_item_title" dir="rtl">حسم التأخر :</span>  
    </div>
    <div className="salaryShow_info_left_item">
        <span className="salaryShow_info_left_item_info" dir="rtl">{salaryData?.salary?.mobile_bill ? numberWithCommas(salaryData?.salary?.mobile_bill) : 0}</span>
        <span className="salaryShow_info_left_item_title" dir="rtl">فاتورة الجوال :</span>  
    </div>
    <div className="salaryShow_info_left_item salaryShow_info_left_item_sanc">
        <span className="salaryShow_info_left_item_info" dir="rtl">{salaryData?.salary?.punishments ? numberWithCommas(salaryData?.salary?.punishments) : 0}</span>
        <span className="salaryShow_info_left_item_title" dir="rtl">العقوبات :</span>  
    </div>
    <div className="salaryShow_info_left_item">
        <span className="salaryShow_info_left_item_info" dir="rtl">{salaryData?.salary?.ordinary_advance ? numberWithCommas(salaryData?.salary?.ordinary_advance) : 0}</span>
        <span className="salaryShow_info_left_item_title" dir="rtl">سلفة عادية :</span>  
    </div>
    <div className="salaryShow_info_left_item">
        <span className="salaryShow_info_left_item_info" dir="rtl">{salaryData?.salary?.resources_advance ? numberWithCommas(salaryData?.salary?.resources_advance) : 0}</span>
        <span className="salaryShow_info_left_item_title" dir="rtl">سلفة الموارد :</span>  
    </div>
    <div className="salaryShow_info_left_item">
        <span className="salaryShow_info_left_item_info" dir="rtl">{salaryData?.salary?.jop ? numberWithCommas(salaryData?.salary?.jop) : 0 }</span>
        <span className="salaryShow_info_left_item_title" dir="rtl">جوب :</span>  
    </div>
    <div className="salaryShow_info_left_item">
        <span className="salaryShow_info_left_item_info" dir="rtl">{salaryData?.salary?.social_insurance ? numberWithCommas(salaryData?.salary?.social_insurance) : 0}</span>
        <span className="salaryShow_info_left_item_title" dir="rtl">تأمينات اجتماعية :</span>  
    </div>
    <div className="salaryShow_info_left_item">
        <span className="salaryShow_info_left_item_info" dir="rtl">{salaryData?.salary?.income_tax ? numberWithCommas(salaryData?.salary?.income_tax) : 0}</span>
        <span className="salaryShow_info_left_item_title" dir="rtl">ضريبة الدخل :</span>  
    </div>
    <div className="salaryShow_info_left_item">
        <span className="salaryShow_info_left_item_info" dir="rtl">{salaryData?.salary?.cooperat_box ? numberWithCommas(salaryData?.salary?.cooperat_box) : 0}</span>
        <span className="salaryShow_info_left_item_title" dir="rtl">صندوق التعاون :</span>  
    </div>
    <div className="salaryShow_info_left_item">
        <span className="salaryShow_info_left_item_info" dir="rtl">{salaryData?.salary?.severance_pay ? numberWithCommas(salaryData?.salary?.severance_pay) : 0}</span>
        <span className="salaryShow_info_left_item_title" dir="rtl">راتب الانقطاع عن العمل :</span>  
    </div>

  
    </div>
</div>



<div className='salaryShow_info_right'>
    <span className="salaryShow_info_right_title">معلومات الراتب</span>

    <div className="salaryShow_info_right_items">
   
    <div className="salaryShow_info_right_item">
        <span className="salaryShow_info_right_item_info" dir="rtl">{salaryData?.salary?.job_id}</span>
        <span className="salaryShow_info_right_item_title" dir="rtl">الرقم الوظيفي : </span>  
    </div>
    <div className="salaryShow_info_right_item">
        <span className="salaryShow_info_right_item_info" dir="rtl">{salaryData?.salary?.base_salary ? numberWithCommas(salaryData?.salary?.base_salary) : 0}</span>
        <span className="salaryShow_info_right_item_title" dir="rtl">الراتب المقطوع :</span>  
    </div>
    <div className="salaryShow_info_right_item">
        <span className="salaryShow_info_right_item_info" dir="rtl">{salaryData?.salary?.motivations ? numberWithCommas(salaryData?.salary?.motivations) : 0}</span>
        <span className="salaryShow_info_right_item_title" dir="rtl">الحوافز : </span>  
    </div>
    <div className="salaryShow_info_right_item">
        <span className="salaryShow_info_right_item_info" dir="rtl">{salaryData?.salary?.additional ? numberWithCommas(salaryData?.salary?.additional) : 0}</span>
        <span className="salaryShow_info_right_item_title" dir="rtl">المبلغ الاضافي : </span>  
    </div>
    <div className="salaryShow_info_right_item">
        <span className="salaryShow_info_right_item_info" dir="rtl">{salaryData?.salary?.food_allowance ? numberWithCommas(salaryData?.salary?.food_allowance) : 0}</span>
        <span className="salaryShow_info_right_item_title" dir="rtl">بدل الطعام :</span>  
    </div>
    <div className="salaryShow_info_right_item">
        <span className="salaryShow_info_right_item_info" dir="rtl">{salaryData?.salary?.productivity_motivations ? numberWithCommas(salaryData?.salary?.productivity_motivations) : 0}</span>
        <span className="salaryShow_info_right_item_title" dir="rtl">الحوافز الإنتاجية :</span>  
    </div>
    <div className="salaryShow_info_right_item">
        <span className="salaryShow_info_right_item_info" dir="rtl">{salaryData?.salary?.nature_work ? numberWithCommas(salaryData?.salary?.nature_work) : 0}</span>
        <span className="salaryShow_info_right_item_title" dir="rtl">طبيعة العمل :</span>  
    </div>
    <div className="salaryShow_info_right_item">
        <span className="salaryShow_info_right_item_info" dir="rtl">{salaryData?.salary?.variable_compensation ? numberWithCommas(salaryData?.salary?.variable_compensation) : 0}</span>
        <span className="salaryShow_info_right_item_title" dir="rtl">تعويضات متغيرة :</span>  
    </div>
    <div className="salaryShow_info_right_item">
        <span className="salaryShow_info_right_item_info" dir="rtl">{salaryData?.salary?.fixed_compensation ? numberWithCommas(salaryData?.salary?.fixed_compensation) : 0}</span>
        <span className="salaryShow_info_right_item_title" dir="rtl"> مكافأة :</span>  
    </div>
    <div className="salaryShow_info_right_item">
        <span className="salaryShow_info_right_item_info" dir="rtl">{salaryData?.salary?.eidiya ? numberWithCommas(salaryData?.salary?.eidiya) : 0}</span>
        <span className="salaryShow_info_right_item_title" dir="rtl">العيدية :</span>  
    </div>
    <div className="salaryShow_info_right_item">
        <span className="salaryShow_info_right_item_info" dir="rtl">{salaryData?.salary?.total_benefit ? numberWithCommas(salaryData?.salary?.total_benefit) : 0}</span>
        <span className="salaryShow_info_right_item_title" dir="rtl">مجموع الاستحقاق :</span>  
    </div>               
    </div>
</div>
</div>

    {/*for the navivagtion buttons */}
    <NavButtonsComp/>
               
     </>
     }
        


     </div>
    </div>
  )
}

export default SalaryPage